"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBillOfMaterial = void 0;
const common_1 = require("../../common");
class DeleteBillOfMaterial extends common_1.UpdateAction {
}
exports.DeleteBillOfMaterial = DeleteBillOfMaterial;
//# sourceMappingURL=delete-bill-of-material.action.js.map